import styled from 'styled-components';

const numColumns = 12;
const gutterWidth = 24;

export const Row = styled.div`
  display: flex;
  flex: 0 1 auto;
  flex-flow: row wrap;
  margin: 0 -${gutterWidth / 2}px 0 -${gutterWidth / 2}px;
`;

export const Column = styled.div<{ offset?: number; width?: number }>`
  flex: 0 0 ${({ width = 12 }) => (width / numColumns) * 100}%;
  margin-left: ${({ offset = 0 }) => (offset / numColumns) * 100}%;
  max-width: ${({ width = 12 }) => (width / numColumns) * 100}%;
  padding: 0 ${gutterWidth / 2}px 0 ${gutterWidth / 2}px;
`;
